<div class="site-alert-banner" aria-live="polite">
  @for (alert of alerts(); track alert.type) {
    <mat-card [class]="alert.styleClass" data-testid="site-alert-item">
      <div class="site-alert-content">
        <div class="site-alert-message">{{ alert.message }}</div>

        @if (alert.secondaryMessage) {
          <div class="site-alert-secondary">{{ alert.secondaryMessage }}</div>
        }

        @if (alert.safetyDocUrl) {
          <a class="site-alert-link" [href]="alert.safetyDocUrl" target="_blank" rel="noopener noreferrer">
            ◆安全資料のリンク
          </a>
        }
      </div>
    </mat-card>
  }
</div>
